var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBikepark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 30",
    style: {
      enableBackground: "new 0 0 101 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setup-1",
    transform: "translate(-223.000000, -433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "park",
    transform: "translate(192.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,56.1c-1.7,0-3-1.4-3-3.1c0-1.6,1.4-2.8,3-2.9c10.8-0.5,18.3-7.3,23-20.8l0.7-1.9c0,0,0,0,0,0l9.6-0.3 c0,0,0,0,0,0l0.6,2.3c2.4,9.2,7.7,13.5,16.4,13.5c12.9,0,14.7-6.3,15.3-8.4l0.6-1.9c0,0,0,0,0,0l2-0.2c4-0.4,7.6,0.4,10.5,2.3 c2.5,1.7,8.5,6.9,18.2,16.1c1.2,1.1,1.4,3,0.3,4.3c-1.1,1.3-3.1,1.4-4.3,0.2c-11.7-11.1-16-14.6-17.5-15.6 c-1.3-0.9-2.9-1.4-4.7-1.4c0,0,0,0,0,0c-3.7,8.7-12.9,10.6-20.3,10.6c-10.7,0-18.1-5.4-21.5-15.7l-0.8,0 C56.4,47.8,47,55.5,34.1,56.1C34.1,56.1,34,56.1,34,56.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikepark);
export default __webpack_public_path__ + "static/media/bikepark.b935c13259f9da4d6ded463921869dec.svg";
export { ForwardRef as ReactComponent };